import React from 'react';
export function SocialProof() {
  return <section className="section authority" data-id="element-131">
      <div className="authority-block" data-id="element-132">
        <span className="eyebrow" data-id="element-133">Dermaclinic Method</span>
        <h2 className="authority-h2" data-id="element-134">Seis clínicas. Una metodología.</h2>
        <p className="authority-cities" data-id="element-135">
          <span className="city" data-id="element-136">Miami</span>
          <span className="dot" aria-hidden="true" data-id="element-137">
            ·
          </span>
          <span className="city" data-id="element-138">Los Angeles</span>
          <span className="dot" aria-hidden="true" data-id="element-139">
            ·
          </span>
          <span className="city" data-id="element-140">New York</span>
          <span className="dot" aria-hidden="true" data-id="element-141">
            ·
          </span>
          <span className="city" data-id="element-142">Las Vegas</span>
          <span className="dot" aria-hidden="true" data-id="element-143">
            ·
          </span>
          <span className="city" data-id="element-144">Phoenix</span>
          <span className="dot" aria-hidden="true" data-id="element-145">
            ·
          </span>
          <span className="city" data-id="element-146">Houston</span>
        </p>
        <p className="authority-body" data-id="element-147">
          Miles de pacientes preparadas en seis ciudades. Una sola línea de
          criterio clínico. A.R.M.O.N.Y. nace de la experiencia repetida de
          consulta — del trabajo real de preparar mujeres antes de una decisión
          corporal importante. Es el sistema que el equipo Dermaclinic usa con
          sus pacientes; ahora disponible antes de que entres a una.
        </p>
      </div>
    </section>;
}